import {
    GET_CPD_LIST_PROGRESS, GET_CPD_LIST_SUCCESS, GET_CPD_LIST_FAILURE,
    ADD_CPD_PROGRESS, ADD_CPD_SUCCESS, ADD_CPD_FAILURE,
    EDIT_DELETE_CPD_PROGRESS, EDIT_DELETE_CPD_SUCCESS, EDIT_DELETE_CPD_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    cpd: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const customer_product_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_CPD_LIST_SUCCESS:
            return { ...state, cpd: action.cpd, loading: false };
        case GET_CPD_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CPD_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_CPD_PROGRESS:
            return { ...state, loading: true };
        case ADD_CPD_SUCCESS:
            return { ...state, cpd: [...state.cpd, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CPD_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_CPD_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CPD_SUCCESS:
            return {
                ...state,
                cpd: state.cpd.map((cpd) =>
                    cpd.id === action.payload.id ? action.payload : cpd
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CPD_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default customer_product_reducer;